<template>
  <div v-bem="{rtl: $i18n.locale === 'ar'}">
    <!-- <p v-bem:trigger="{animate}" @click="show = true"><inline-svg :src="require('@/assets/img/icons/calculator.svg')" ></inline-svg> {{$t('steps.fund')}}</p> -->
    <div v-bem:wrapper="{show}" v-if="show">
      <div v-bem:wrapper-content>
        <iframe ref="iframe" :src="simulatorLink" scrolling="yes" frameborder="0"></iframe>
        <span v-bem:close @click="show = false">&times;</span>
      </div>
    </div>
    <div v-bem:note="{show: note}">
      <div v-bem:note-content>
        <span v-bem:close @click="note = false">&times;</span>
        <p>{{$t('steps.fund-message')}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/event-bus'
import { mapGetters } from 'vuex'
import InlineSvg from 'vue-inline-svg'

export default {
  name: 'SimulatorWidget',
  components: {
    InlineSvg
  },
  data: () => ({
    show   : false,
    note   : false,
    animate: false
  }),
  computed: {
		...mapGetters([
      'model',
      'version',
      'total',
      'apport',
      'trade',
      'tradeCar',
    ]),
    simulatorLink() {
      const source  = 5
      const brand   = process.env.VUE_APP_THEME === 'renault' ? 1 : 2
      const model   = this.model.id_simulateur_modele
      const version = this.version.id_simulateur
      const apport =  this.trade ? this.apport : Math.round(this.total / 2).toFixed(0)
      return `${process.env.VUE_APP_RCI_ORIGIN}/succsimulateur/${source}/${brand}/${model}/${version}/${this.total}/${apport}`
    }
  },
  mounted() {
    EventBus.$on('show-simulator-widget', () => this.show = true)
    EventBus.$on('mensualite-changed', () => {
      // this.animate = false
      // setTimeout(() => this.animate = true, 200)
      this.note = true
      // setTimeout(() => this.note = false, 7000)
    })
    const $this = this
    window.addEventListener('message', function(event) {
      if (event.origin === process.env.VUE_APP_RCI_ORIGIN) {
        if (!event.data.pcmPixelPostMessageEvent) {
          $this.$store.dispatch('setMonthlyPayment', event.data)
          $this.show = false
          EventBus.$emit('highlight-mensualite')
        }
      }
    })
  }
}
</script>

<style scoped lang="scss">
.simulator-widget {
  &__trigger {
    position: fixed;
    left: 0;
    top: 30%;
    color: $white;
    background-color: $orange;
    text-align: center;
    padding: rem(16) rem(8);
    font-family: var(--primary-font-bold);
    cursor: pointer;
    z-index: 9;
    writing-mode: vertical-rl;
    text-orientation: mixed;
    transition: background 0.3s ease-out;
    display: none;
    svg {
      fill: $white;
      margin-right: rem(4);
      margin-bottom: rem(8);
    }
    &:hover {
      background-color: darken($orange, 5%);
    }
    &--animate {
      // animation: scale 1s;
      // animation-iteration-count: 3;
    }
  }
  &__wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 99999999999;
    background-color: rgba($black, 0.7);
    &-content {
      @extend %transform-center;
      width: 95%;
      max-width: rem(960);
      height: 90%;
    }
    iframe {
      width: 100%;
      height: 100%;
    }
  }
  &__close {
    position: absolute;
    top: rem(4);
    right: rem(24);
    @include font-size(22);
    font-weight: bold;
    cursor: pointer;
  }
  &__note {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba($black, 0.7);
    z-index: 99999999999;
    display: none;
    &-content {
      @extend %transform-center;
      width: 95%;
      max-width: rem(420);
      border: rem(1) solid $orange;
      background-color: $white;
      padding: rem(16);
      color: $orange;
      text-align: center;
    }
    .simulator-widget__close {
      top: rem(0);
      right: rem(8);
      color: $main-color;
    }
    &--show {
      display: block;
    }
  }
  &--rtl {
    .simulator-widget__trigger {
      left: unset;
      right: 0;
      svg {
        fill: $white;
        margin-right: unset;
        margin-left: rem(4);
        margin-top: rem(8);
        margin-bottom: unset;
      }
    }
  }
  @include breakpoint('charmander') {
    &__trigger {
      display: block;
      top: unset;
      bottom: 0;
      width: 100%;
      padding: rem(8);
      writing-mode: unset;
      svg {
        margin-right: rem(4);
        margin-bottom: 0;
        vertical-align: text-bottom;
      }
    }
    &__wrapper {
      display: block;
      top: 100%;
      transition: top 0.6s ease-out;
      &--show {
        top: 0;
      }
      &-content {
        width: 100%;
        height: 100%;
      }
    }
    &__note {
      &-content {
        padding: rem(10) rem(16);
      }
    }
  }
}
@keyframes scale { 50% { transform: scale(1.1); }  }
</style>